import React from "react";
import styles from "./ProjectExclusionTable.module.css";
import { Checkbox } from "@atlaskit/checkbox";
import { createKey } from "../../../helpers/helpers";

export const TableWrapper = ({ children }) => (
  <div className={styles.tableWrapperStyles}>{children}</div>
);

export const createHead = (
  withWidth,
  handleCheckboxCheckAll,
  isLoading,
  globalCheckState,
  checkedProjects,
  data,
  disabled
) => {
  return {
    cells: [
      {
        content: (
          <Checkbox
            isDisabled={globalCheckState.disabled || isLoading || disabled}
            isChecked={globalCheckState.allChecked}
            isIndeterminate={
              data
                ? checkedProjects > 0 && checkedProjects < data.length
                : false
            }
            value="All"
            name="parent"
            type="checkbox"
            onChange={(e) => handleCheckboxCheckAll(e)}
          />
        ),
        key: "selectRow",
        isSortable: false,
        width: withWidth ? 5 : undefined,
      },
      {
        content: "Project",
        key: "ProjectName",
        isSortable: true,
        isFixedSize: true,
        width: withWidth ? 50 : undefined,
      },
      {
        content: "Issue count",
        key: "IssueCount",
        isFixedSize: true,
        isSortable: true,
        width: withWidth ? 20 : undefined,
      },
    ],
  };
};

export const createCells = (
  projectList,
  handleCheckboxCheck,
  checkedProjects,
  disabled
) => {
  return projectList.map((data, index) => {
    return {
      key: `row-${index}-${data.projectId}`,
      cells: [
        {
          key: createKey("selectRow"),
          // content: (
          //   <Checkbox
          //     key={data.projectId}
          //     isDisabled={
          //       tempCheckedItems[data.projectId] !== true &&
          //       checkedIssues.length > 49
          //         ? true
          //         : false
          //     }
          //     isChecked={
          //       tempCheckedItems !== [] ? tempCheckedItems[data.projectId] : false
          //     }
          //     name={data.projectId}
          //     onChange={(e) => {
          //       handleCheckboxCheck(e, data);
          //     }}
          //   />
          // ),
          content: (
            <Checkbox
              key={data.projectId}
              isChecked={
                checkedProjects !== []
                  ? checkedProjects.filter(
                      (ele) => ele.projectId === data.projectId
                    ).length !== 0
                  : false
              }
              name={data.projectId}
              isDisabled={disabled}
              onChange={(e) => {
                handleCheckboxCheck(e, data);
              }}
            />
          ),
        },
        {
          key: createKey(data.projectName),
          content: data.projectName,
        },
        {
          key: data.issueCount,
          content: data.issueCount,
        },
      ],
    };
  });
};
